<template>
  <div>
    <v-snackbar
      v-model="message.snackbar"
      :timeout="message.snackbarTimeout"
      bottom
    >
      {{ message.snackbarText }}
      <v-btn dark text @click="message.snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-dialog v-model="createEventDialog" scrollable max-width="500px">
      <v-card>
        <v-card-title>Create event</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-alert type="error" class="mt-5" v-if="showEventMessage" dense
            >Duplicate event code entered</v-alert
          >
          <v-form ref="createEventForm">
            <v-text-field
              v-model="companyEventForm.name"
              label="Event name"
              :rules="[rules.required]"
              required
            ></v-text-field>

            <v-select
              v-model="companyEventForm.type"
              :items="eventTypes"
              :rules="[rules.required]"
              label="Type"
            ></v-select>

            <v-text-field
              v-model="companyEventForm.code"
              label="Code"
              :rules="[rules.required]"
              required
            ></v-text-field>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn
            color="blue darken-1"
            text
            @click="createEventDialog = false"
            class="hp--btn"
            >Close</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="onCreateEvent()"
            class="hp--btn"
            >Save</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="updateEventCodeDialog" scrollable max-width="500px">
      <v-card>
        <v-card-title>Update event code</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-alert
            type="error"
            class="mt-5"
            v-if="showUpdateEventCodeMessage"
            dense
            >Duplicate event code entered</v-alert
          >
          <v-form ref="updateEventCode">
            <v-text-field
              v-model="updateEventCode.code"
              label="Code"
              :rules="[rules.required]"
              required
            ></v-text-field>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn
            color="blue darken-1"
            text
            @click="updateEventCodeDialog = false"
            class="hp--btn"
            >Close</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="onUpdateEventCode()"
            class="hp--btn"
            >Save</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-card class="mx-auto" max-width="1000">
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn
            color="info"
            dark
            small
            absolute
            top
            right
            fab
            v-on="on"
            @click="sendMessageToParent"
            class="hp--btn"
          >
            <v-icon>keyboard_return</v-icon>
          </v-btn>
        </template>
        <span>View companies</span>
      </v-tooltip>

      <v-toolbar flat>
        <v-toolbar-title class="grey--text">Events</v-toolbar-title>
        <div class="flex-grow-1"></div>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              color="primary"
              dark
              small
              absolute
              bottom
              fab
              v-on="on"
              @click="createEventDialog = !createEventDialog"
              class="hp--btn"
            >
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </template>
          <span>Create event</span>
        </v-tooltip>
      </v-toolbar>
      <v-divider></v-divider>
      <v-card-text>
        <div v-for="event in events" :key="event.id">
          <v-layout row wrap class="ma-1">
            <v-flex xs12 sm4 lg5>
              <div class="caption grey--text">Name</div>
              <div class="black--text">{{ event.name }}</div>
            </v-flex>
            <v-flex xs12 md2 lg2>
              <div class="caption grey--text">Code</div>
              <div class="black--text">{{ event.code }}</div>
            </v-flex>
            <v-flex xs12 md1 lg1>
              <div class="caption grey--text">Status</div>
              <div class="black--text" v-if="event.status">
                {{ event.status }}
              </div>
            </v-flex>
            <v-flex xs12 md2 lg2>
              <div class="caption grey--text">Type</div>
              <div class="black--text">
                {{ getEventTypeLabel(event.type) }}
              </div>
            </v-flex>
            <v-flex xs12 sm3 lg2>
              <div class="float-right">
                <v-tooltip bottom v-if="event.type === 'workshop'">
                  <template v-slot:activator="{ on }">
                    <v-btn
                      fab
                      dark
                      x-small
                      color="purple"
                      @click="goToFeedbackSurvey"
                    >
                      <v-icon v-on="on" dark>people</v-icon>
                    </v-btn>
                  </template>
                  <span>Feedback Survey</span>
                </v-tooltip>
                <v-btn v-else fab dark x-small color="grey">
                  <v-icon disabled dark>people</v-icon>
                </v-btn>

                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      class="mx-1 hp--btn"
                      fab
                      dark
                      x-small
                      color="warning"
                      @click="editEventCode(event)"
                    >
                      <v-icon v-on="on" dark>code</v-icon>
                    </v-btn>
                  </template>
                  <span>Update event code</span>
                </v-tooltip>

                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      class="mx-1 hp--btn"
                      fab
                      dark
                      x-small
                      color="success"
                      @click="editEvent(event)"
                    >
                      <v-icon v-on="on" dark>edit</v-icon>
                    </v-btn>
                  </template>
                  <span>Edit event</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      class="mx-1 hp--btn"
                      fab
                      dark
                      x-small
                      color="error"
                      @click="deleteEvent(event)"
                    >
                      <v-icon v-on="on" dark>delete_outline</v-icon>
                    </v-btn>
                  </template>
                  <span>Delete event</span>
                </v-tooltip>
              </div>
            </v-flex>
          </v-layout>
          <v-divider></v-divider>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import { Company } from "../classes/Company";
import { Event } from "../classes/Event";
import _ from "lodash";
export default {
  props: {
    company: Object
  },
  data() {
    return {
      events: [],
      eventTypes: [
        { text: "Slot", value: "slot" },
        { text: "Workshop", value: "workshop" },
        { text: "Register Interest", value: "register" },
        { text: "Health Screening", value: "healthscreening" },
        { text: "Virus Testing", value: "virustesting" }
      ],
      createEventDialog: false,
      updateEventCodeDialog: false,
      showEventMessage: false,
      companyEventForm: [],
      showUpdateEventCodeMessage: false,
      updateEventCode: [],
      rules: {
        required: v => !!v || "This field is required.",
        email: v => /.+@.+\..+/.test(v) || "E-mail must be valid"
      },
      message: {
        snackbar: false,
        snackbarText: "",
        snackbarTimeout: 3000
      }
    };
  },
  async created() {
    const that = this;
    this.events = [];

    const events = await new Event().getEventsByCompany(this.company);

    events.forEach(function(event) {
      that.events.push({
        id: event.id,
        name: event.name,
        code: event.code,
        type: event.type,
        status: event.status,
        requireDob: event.requireDob
      });
    });
    that.events = _.orderBy(that.events, "name", "asc"); // Lodash sort
  },
  methods: {
    sendMessageToParent() {
      this.$emit("switchEventPanel", "companies");
    },
    editEvent(event) {
      this.$router.push({
        name: "event",
        params: { eventType: event.type.toLowerCase(), eventId: event.id }
      });
    },
    editEventCode(event) {
      this.updateEventCode.code = event.code;
      this.updateEventCode.id = event.id;

      this.updateEventCodeDialog = true;
    },
    async onCreateEvent() {
      if (this.$refs.createEventForm.validate()) {
        const isDuplicate = await new Company().isDuplicateCode(
          this.companyEventForm.code.toLowerCase().trim()
        );
        this.showEventMessage = false;
        if (isDuplicate) {
          this.showEventMessage = true;
          return;
        }
        const event = await new Event().createEvent(
          this.company.id,
          this.companyEventForm
        );
        this.events.push({
          id: event.id,
          name: event.name,
          code: event.code,
          type: event.type,
          status: event.status,
          eventCompany: event.eventCompany,
          requireDob: event.requireDob,
          createdAt: event.createdAt
        });
        this.events = _.orderBy(this.events, "name", "asc");
        this.createEventDialog = false;
        this.showSuccessMessage("New event " + event.name + " created");
      }
    },
    async onUpdateEventCode() {
      const that = this;
      if (this.$refs.updateEventCode.validate()) {
        const code = this.updateEventCode.code.toLowerCase().trim();
        const isDuplicate = await new Company().isDuplicateCode(code);
        this.showUpdateEventCodeMessage = false;
        if (isDuplicate) {
          this.showUpdateEventCodeMessage = true;
          return;
        }
        if (this.updateEventCode.id) {
          const event = await new Event().updateEventCode(this.updateEventCode);
          const index = that.events.findIndex(evt => evt.id === event.id);
          that.events[index].code = event.code;
          that.updateEventCodeDialog = false;
        }
      }
    },
    async deleteEvent(event) {
      if (confirm("Are you sure you want to delete this event?")) {
        const eventResult = await new Event().deleteEvent(event);
        this.events.splice(this.events.indexOf(eventResult), 1);
        this.showSuccessMessage("Event deleted");
      }
    },
    getEventTypeLabel(type) {
      const filteredType = this.eventTypes.filter(evtype => {
        return evtype.value === type;
      });
      return filteredType[0].text;
    },
    goToFeedbackSurvey() {
      window.open("https://loop.healthyperformance.co.uk", "_blank");
    },
    showSuccessMessage(message) {
      this.message.snackbarText = message;
      this.message.snackbar = true;
    }
  }
};
</script>
